import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nxt-shared-auth-wrapper',
  templateUrl: './shared-auth-wrapper.component.html',
  styleUrls: ['./shared-auth-wrapper.component.scss'],
})
export class SharedAuthWrapperComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}

}
